export enum MotProviderLogoUrlTypes {
  dvsa = '../../assets/images/DVSA_logo.png',
  nmr = '../../assets/images/nmr_logo.png',
  bca = '../../assets/images/BCA_logo.png'
}
